import {IBaseLookup} from "./Ibase.lookup";

export namespace DeliveryMethod {

    export const lookupName: string = "DeliveryMethod";

    export interface DeliveryMethod {
        deliveryMethodKey: number;
        code: string;
        description: string;
        postToQueue: string;
        active: string;
        lastUpdated: Date;
        forPatientUse: string;
        forResourceUse: string;
        criticalResultsContact: string;
    }

    export interface DeliveryMethodDS extends IBaseLookup {
        deliveryMethod: DeliveryMethod[];
    }
}
